import SectionHero from "components/SectionHero/SectionHero";
import React, { useState, useEffect } from "react";
// import SectionSubscribe2 from "components/SectionSubscribe2/SectionSubscribe2";
// import SectionOurFeatures from "components/SectionOurFeatures/SectionOurFeatures";
// import SectionGridFeaturePlaces from "./SectionGridFeaturePlaces";
import { useDispatch, useSelector } from "react-redux";
import SectionGridFeatureRent from "./SectionGridFeatureRenty";
import SectionHowItWork from "components/SectionHowItWork/SectionHowItWork";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import { TaxonomyType } from "data/types";
import { RootState } from "store";
import { getCategoryCount } from "actions/productActions";
// import SectionGridAuthorBox from "components/SectionGridAuthorBox/SectionGridAuthorBox";
// import SectionGridCategoryBox from "components/SectionGridCategoryBox/SectionGridCategoryBox";
import SectionBecomeAVendor from "components/SectionBecomeAnAuthor/SectionBecomeAnAuthor";
// import SectionVideos from "./SectionVideos";
// import SectionClientSay from "components/SectionClientSay/SectionClientSay";
import { Helmet } from "react-helmet";
import ButtonTop from "shared/Button/ButtonTop";
import SectionCategory from "components/SectionSliderNewCategories/SectionCategory";
import SectionSliderNewCategories from "components/SectionSliderNewCategories/SectionSliderNewCategories";
import bedugulCategory from "images/home/bedugul-01-01.png";
import dbCategory from "images/home/db-01-01.png";
import dsCategory from "images/home/ds-01-01.png";
import duCategory from "images/home/du-01-01.png";
import dtCategory from "images/home/dt-01-01.png";
import kintamaniCategory from "images/home/kintamani-01-01.png";
import category1 from "images/home/category0.jpg";
import category2 from "images/home/category1.jpg";
import category3 from "images/home/category2.jpg";
import ButtonScroll from "shared/Button/ButtonScroll";
import Scroll from "react-scroll";

interface ICategory {
  kintamani: number;
  bedugul: number;
  db: number;
  dt: number;
  du: number;
  ds: number;
}

const PageHome = () => {
  const dispatch = useDispatch();

  const { categoryCount } = useSelector(
    (state: RootState) => state.categoryCount
  );

  const [category, setCategory] = useState<ICategory>({
    kintamani: 0,
    bedugul: 0,
    db: 0,
    dt: 0,
    du: 0,
    ds: 0,
  });
  // eslint-disable-next-line
  const scroll = Scroll.scroller;
  // eslint-disable-next-line
  const [focus, setFocus] = useState<boolean>(false);

  useEffect(() => {
    dispatch(getCategoryCount());
  }, []);

  useEffect(() => {
    if (categoryCount) setCategory(categoryCount);
  }, [categoryCount]);

  // eslint-disable-next-line
  const DEMO_CATS: TaxonomyType[] = [
    {
      id: "2",
      href: "/map?location=kintamani",
      name: "Kintamani",
      taxonomy: "category",
      count: category.kintamani || 0,
      thumbnail: kintamaniCategory,
    },
    {
      id: "2",
      href: "/map?location=buyan",
      name: "Buyan - Tamblingan",
      taxonomy: "category",
      count: category.bedugul || 0,
      thumbnail: bedugulCategory,
    },
    {
      id: "3",
      href: "/map?location=denpasar-barat",
      name: "Denpasar Barat",
      taxonomy: "category",
      count: category.db || 0,
      thumbnail: dbCategory,
    },
    {
      id: "4",
      href: "/map?location=denpasar-timur",
      name: "Denpasar Timur",
      taxonomy: "category",
      count: category.dt || 0,
      thumbnail: dtCategory,
    },
    {
      id: "5",
      href: "/map?location=denpasar-selatan",
      name: "Denpasar Selatan",
      taxonomy: "category",
      count: category.ds || 0,
      thumbnail: dsCategory,
    },
    {
      id: "2",
      href: "/map?location=denpasar-utara",
      name: "Denpasar Utara",
      taxonomy: "category",
      count: category.du || 0,
      thumbnail: duCategory,
    },

    // {
    //   id: "2",
    //   href: "/map?location=karangasem",
    //   name: "Karangasem",
    //   taxonomy: "category",
    //   count: category.selfNeeds || 0,
    //   thumbnail:
    //     "https://renttrips.id/wp-content/uploads/2021/09/Keperluan-Pribadi-1.png",
    // },
  ];

  const CATEGORY: TaxonomyType[] = [
    {
      id: "1",
      href: "/listing?category=Outdoor",
      name: "Camping & Hiking",
      taxonomy: "category",
      thumbnail: category1,
    },
    {
      id: "2",
      href: "/listing?category=Gadget",
      name: "Fotografi",
      taxonomy: "category",
      thumbnail: category2,
    },
    {
      id: "3",
      href: "/listing",
      name: "Lainnya",
      taxonomy: "category",
      thumbnail: category3,
    },
  ];

  return (
    <div className="nc-PageHome relative overflow-hidden">
      <Helmet>
        <title>Rentrips.id</title>
      </Helmet>
      {/* GLASSMOPHIN */}
      <BgGlassmorphism />

      <div className="container relative space-y-8 mb-24 lg:space-y-32 lg:mb-32">
        {/* SECTION HERO */}
        <SectionHero className="pt-10 lg:pt-28 pb-5 lg:pb-16" focus={focus} />

        {/* SECTION BUAT TEMPAT STAY */}
        {/* <div className="relative py-16">
          <BackgroundSection />
          <SectionGridFeaturePlaces />
        </div> */}

        {/* SECTION KATEGORI */}
        <SectionSliderNewCategories
          categories={DEMO_CATS}
          descLink="/contact"
          heading="Area Vendor Terpercaya Rentrips"
          subHeading="Punya request sama Rentrips? "
        />
        <SectionCategory
          categories={CATEGORY}
          heading="Lengkapi Kebutuhan Outdoor Kamu"
          subHeading=""
        />

        {/* SECTION BARANG - BARANG */}
        <div className="relative py-16">
          <BackgroundSection />
          <SectionGridFeatureRent
            query="category=Outdoor"
            heading="🌴 Buat kamu yang pencinta alam"
            subHeading="Barang-barang keperluan camping dan outdoor lainnya"
          />
        </div>
        {/* SECTION BARANG - BARANG */}
        {/* <div className="relative py-16">
          <SectionGridFeatureRent
            query="category=Transportasi"
            heading="🚙 Perjalanan jauh? Siapa Takut!"
            subHeading="Barang-barang sewa untuk menemai perjalanan berhargamu"
          />
        </div> */}

        {/* <div className="relative py-16">
          <BackgroundSection />
          <SectionGridFeatureRent
            query="category=Gadget"
            heading="📷 Abadikan setiap momentmu!"
            subHeading="Gadget-gadget kece yang siap menemani liburanmu"
          />
        </div> */}

        {/* SECTION 
        <SectionOurFeatures /> */}

        {/* SECTION CARA KERJA RENTRIPS */}
        <SectionHowItWork />

        {/* SECTION 1 
        <div className="relative py-16">
          <BackgroundSection className="bg-orange-50 dark:bg-black dark:bg-opacity-20 " />
          <SectionSliderNewCategories
            categories={DEMO_CATS_2}
            categoryCardType="card4"
            itemPerRow={4}
            heading="Suggestions for discovery"
            subHeading="Popular places to stay that Chisfis recommends for you"
            sliderStyle="style2"
          /> 
        </div> */}

        {/* SECTION 
        <SectionSubscribe2 /> */}

        {/* SECTION 
        <div className="relative py-16">
          <BackgroundSection className="bg-orange-50 dark:bg-black dark:bg-opacity-20 " />
          <SectionGridAuthorBox />
        </div> */}

        {/* SECTION 
        <SectionGridCategoryBox /> */}

        {/* SECTION 1 
        <SectionSliderNewCategories
          heading="Explore by types of stays"
          subHeading="Explore houses based on 10 types of stays"
          categoryCardType="card5"
          itemPerRow={5}
        /> */}

        {/* SECTION VIDEO
        <SectionVideos /> */}

        {/* SECTION 
        <div className="relative py-16">
          <BackgroundSection />
          <SectionClientSay /> 
        </div>*/}
        {/* SECTION TERTARIK MENJADI VENDOR ?*/}
        <div className="relative py-16">
          <BackgroundSection />
          <SectionBecomeAVendor />
        </div>
      </div>
      <ButtonScroll
        onClick={() => {
          scroll.scrollTo("search", {
            duration: 1500,
            delay: 100,
            smooth: true,
            offset: 200,
          });
          setTimeout(() => {
            setFocus(true);
          }, 2000);
          setFocus(false);
        }}
      />
      <ButtonTop />
    </div>
  );
};

export default PageHome;
